import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2758cb60")

_pushScopeId("data-v-2758cb60")
const _hoisted_1 = { class: "r-grid navigation" }
const _hoisted_2 = { href: "https://www.uic.edu/" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { "aria-label": "Primary" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" New Request ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Leave Balance ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Manage Employees ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" HR Admin ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Holidays ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Logout ")
const _hoisted_12 = /*#__PURE__*/_createVNode("h1", { class: "r-grid site-name" }, "GoTime", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("header", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("a", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _ctx.circleLogoSVG,
            alt: "UIC Circle Mark"
          }, null, 8, ["src"])
        ])
      ]),
      _createVNode("nav", _hoisted_4, [
        _createVNode("button", {
          class: "menu-button-wrapper",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu())),
          "aria-label": "toggle navigation menu"
        }, [
          _createVNode("div", {
            class: [{ 'active': _ctx.menuOpen }, "menu-button"]
          }, null, 2)
        ]),
        (_ctx.userInfoData)
          ? _withDirectives((_openBlock(), _createBlock("ul", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMenu())),
              id: "nav",
              "aria-label": "navigation menu"
            }, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                (_ctx.userInfoData.isEmployee)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/new-request"
                    }, {
                      default: _withId(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("li", null, [
                (_ctx.userInfoData.isEmployee)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/leave-balance"
                    }, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("li", null, [
                (_ctx.userInfoData.isSupervisor)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/manage-employees"
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("li", null, [
                (_ctx.userInfoData.isHRAdmin)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/hr-admin"
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: "/holidays" }, {
                  default: _withId(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: "/logout" }, {
                  default: _withId(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ])
            ], 512)), [
              [_vShow, _ctx.menuOpen]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_router_link, {
      class: "banner",
      to: "/"
    }, {
      default: _withId(() => [
        _hoisted_12
      ]),
      _: 1
    })
  ]))
})